import { render, staticRenderFns } from "./GenerationHistoryListView.vue?vue&type=template&id=1897b2a2"
import script from "./GenerationHistoryListView.vue?vue&type=script&lang=js"
export * from "./GenerationHistoryListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports